import React from 'react';
import './AboutHeader.css';

const stats = [
    { number: "12+", label: "Years of Experience" },
    { number: "100+", label: "Equipment Models" },
    { number: "500+", label: "Clinics & Hospitals" },
    { number: "1000+", label: "Installations" },
    { number: "Trusted", label: "Across India" }
];

const AboutHeader = () => {
    return (
        <section className="about-header-section">
            <div className="about-header-container">
                <div className="about-header-content">
                    <div className="about-header-left">
                        <span className="section-subtitle">ABOUT PRIME REHAB</span>
                        <h1 className="about-main-title">
                            Precision Physiotherapy<br />
                            Equipment for Modern<br />
                            Rehabilitation
                        </h1>
                    </div>

                    <div className="about-header-right">
                        <p className="about-header-desc">
                            Prime Rehab Industries designs reliable physiotherapy and rehabilitation equipment for clinics, hospitals, and therapy centers. Our focus is on quality, durability, and patient comfort.
                        </p>
                    </div>
                </div>

                <div className="about-header-stats-grid">
                    {stats.map((stat, index) => (
                        <div className="about-header-stat" key={index}>
                            <h3 className="about-stat-num">{stat.number}</h3>
                            <p className="about-stat-label">{stat.label}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="about-hero-image">
                <img
                    src="https://primerehabindustries.in/Image/About/AbtHero.png"
                    alt="Rehabilitation Center Setup"
                />
            </div>
        </section>
    );
};

export default AboutHeader;
